import { createContext, useContext } from "react";

/**
 * Ablagestelle für Vollflächen im Inhaltsbereich des App-Rahmens (z. B. `WizardOverlay`): Sie decken nur
 * den Inhalt ab, Navigation und obere Zeile bleiben stehen. `null` außerhalb des Rahmens und in der
 * Mobilansicht — dort deckt die Vollfläche das ganze Fenster ab.
 */
export const AppShellOverlayHostContext = createContext<HTMLElement | null>(null);

export function useAppShellOverlayHost(): HTMLElement | null {
  return useContext(AppShellOverlayHostContext);
}
